import lodash from "lodash";
import { createField } from "./open-inspection-info.section";
import store from "../../../../../../store";

export const initForm = ({ props, data, refs }) => {
    const key = props.dataKey;
    const isLoading = props.isLoading;
    data.fields = createField({ props, data, refs, key, isLoading });
};

export const createForm = ({ refRelease }) => {
    const form = {
        isSave: true,
        inspectionDatetime: null,
        refTransportByWay: null,
        vehicleNo: null,
        netWeight: null,
        refNetWeightUnit: null,
        qty: null,
        refQtyUnit: null,
        qtySampling: null,
        refQtySamplingUnit: null,
        boxNo: null,
        sealNo: null,
    };
    if (refRelease) {
        const userInfo = store.state.resource.auth.info?.user;
        form.refDepartment = refRelease.refDepartment;
        form.refUserCompany = refRelease.refUserCompany;
        form.refUser = refRelease.refUser;
        form.refOfficer = lodash.cloneDeep(userInfo);
    }
    return form;
};